export const mealTypes = {
  state: {
    mealCountDtos: 'mealCountDtos',
    mealCountStatuses: 'mealCountStatuses',
    lastSyncUtc: 'lastSyncUtc',
    tempDto: 'tempDto',
    requestsToSyncUp: 'requestsToSyncUp',
    mergeServingLines: 'mergeServingLines'
  },
  mutations: {
    updateCountDto: 'updateCountDto',
    updateCountStatus: 'updateCountStatus',
    updateSyncDate: 'updateSyncDate',
    updateTempDto: 'updateTempDto',
    updateRequestToSyncUp: 'updateRequestToSyncUp',
    clearSyncUp: 'clearSyncUp',
    updateMergeServingLines: 'updateMergeServingLines',
    clearServingLines: 'clearServingLines'
  },
  actions: {
    updateCountDto: 'updateCountDto',
    updateMultipleCountDtos: 'updateMultipleCountDtos',
    updateRequestToSyncUp: 'updateRequestToSyncUp',
    setTempDto: 'setTempDto',
    clearSyncUp: 'clearSyncUp',
    updateSyncDates: 'updateSyncDates',
    updateCountStatus: 'updateCountStatus',
    updateCountStatuses: 'updateCountStatuses',
    updateMergeServingLines: 'updateMergeServingLines',
    clearServingLines: 'clearServingLines'
  }
};
